import React, { useState, useRef } from "react";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import Translator from "Languages/Utility/Translator";
import {
  Dialog,
  DialogActions,
  DialogContent,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import MuiButton from "Components/MuiButton/MuiButton";
import * as Icons from "react-bootstrap-icons";
import { read, store } from "Helpers/LocalStorage";
import AccountService from "Services/http/endpoints/superadmin/AccountsEndpoints";
import StatusHandler from "Helpers/StatusHandler";
import { useTranslation } from "react-i18next";
import { Skeleton } from "@material-ui/lab";
import showNotify from "Helpers/Notify";
import { useDispatch, useSelector } from "react-redux";
import { TRANSFER } from "Stores/actionTypes";
import BackDropLoading from "Components/BackDropLoading2/BackDropLoading";
import { createFakeStorage } from "Helpers/analyzeToken";
import DialogHead from "Components/DialogHead/DialogHead";

export default function Infos({ row }) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [transferLoading, setTransferLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showDialog, setShowDialog] = useState(false);
  const [data, setData] = useState(null);
  const dashboard_tab = useRef(null);
  const { transfer } = useSelector((state) => ({
    transfer: state.auth.transfer,
  }));
  const onShowDialog = () => {
    setShowDialog(true);
  };

  const onEnter = async () => {
    try {
      setLoading(true);
      const params = {
        KeyGroup: read("groupAKey"),
        KeyUser: read("userAKey"),
        GroupId: row.Id,
      };
      const response = await AccountService.getAccountGroupInfo(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        setData(response.data.Value);
      }
      setTimeout(() => {
        setLoading(false);
      }, 500);
    } catch (e) {
      showNotify({ text: "getDataError", customClass: "error" });
      setShowDialog(false);
    }
  };

  function AccountInfo({ header, content, Icon }) {
    return (
      <p className="m-0 p-1">
        <span className="ms-2">{Icon}</span>
        <span className="text-muted">{`${header} : `}</span>
        <strong>{content}</strong>
      </p>
    );
  }

  const enterDashboard = async () => {
    if (!transfer) {
      setTransferLoading(true);
      createFakeStorage(data.Param1, data.Param2);
      dispatch({ type: TRANSFER, transfer: true });
      store("StypeSwAllow", true);
      showNotify({
        text: t("enterDashboard"),
        customClass: "success",
      });
      setTimeout(() => {
        setTransferLoading(false);
        dashboard_tab.current = window.open(
          window.location.origin + "/dashboard",
          "_blank",
        );
        dashboard_tab.current.focus();
        const dashboard_tab_interval = setInterval(() => {
          if(!read("StypeSwAllow")) {
            try {
              dashboard_tab.current.close();
            } catch (err) {
              console.error("[catch error]", err);
            }
            clearInterval(dashboard_tab_interval);
          }
        }, 1000);
      }, 1000);
    } else {
      showNotify({
        text: t("enterDashboardError"),
        customClass: "warning",
      });
    }
  };

  const onExit = () => {
    setShowDialog(false);
  };

  return (
    <>
      <ActionFormatter
        title={<Translator id="infos" />}
        icon={<Icons.InfoCircle />}
        onClick={onShowDialog}
        className="primary-button"
      />
      <Dialog
        dir={direction}
        open={showDialog}
        onClose={onExit}
        TransitionProps={{ onEnter: onEnter, onExit: onExit }}
        fullWidth
        maxWidth="sm"
      >
        <BackDropLoading loading={transferLoading} />
        <form>
          <DialogHead
            text={<Translator id="infos" />}
            subtext={row.Name}
            icon={<Icons.InfoCircle />}
          />
          {loading ? (
            <div className=" p-3">
              <Skeleton variant="text" className="p-2" animation="wave" />
              <Skeleton variant="text" className="p-2" animation="wave" />
              <Skeleton variant="text" className="p-2" animation="wave" />
              <Skeleton variant="text" className="p-2" animation="wave" />
              <Skeleton variant="text" className="p-2" animation="wave" />
            </div>
          ) : (
            <>
              <DialogContent>
                <div className="d-felx flex-column align-items-start">
                  {data && data !== "" ? (
                    <>
                      <div className="w-100 d-flex flex-column align-items-start">
                        <h6>{t("info_userAccountInfo")}</h6>
                        <div className="info-dataBox pr-3">
                          <AccountInfo
                            header={t("info_countUser")}
                            content={data.CountUser}
                            Icon={<Icons.PeopleFill size={17} />}
                          />
                          <AccountInfo
                            header={t("info_credit")}
                            content={`${data.Credit.toLocaleString()} ${t(
                              "moneyUnit"
                            )}`}
                            Icon={<Icons.Coin size={17} />}
                          />
                          <AccountInfo
                            header={t("info_jalaliDate")}
                            content={data.JalaliDate}
                            Icon={<Icons.Calendar3 size={17} />}
                          />
                          <AccountInfo
                            header={t("info_jalaliDay")}
                            content={data.JalaliDay}
                            Icon={<Icons.CalendarDayFill size={17} />}
                          />
                          <AccountInfo
                            header={t("info_period")}
                            content={data.Period}
                            Icon={<Icons.Bag size={17} />}
                          />
                          <AccountInfo
                            header={t("info_show")}
                            content={t(`info_show_${data.Show}`)}
                            Icon={<Icons.SignpostSplit size={17} />}
                          />
                        </div>
                      </div>
                      <div className="w-100 border-bottom my-3"></div>
                      <div className="w-100 d-flex flex-column align-items-start">
                        <h6>{t("info_userAccountRemain")}</h6>

                        <div className="remaing-time">
                          {data.RemaingTime.Years.toString() !== "0" && (
                            <div>
                              <strong style={{ fontSize: "16px" }}>
                                {data.RemaingTime.Years}
                              </strong>
                              <p className="m-0">{t("info_Years")}</p>
                            </div>
                          )}
                          {data.RemaingTime.Months.toString() !== "0" && (
                            <div>
                              <strong style={{ fontSize: "16px" }}>
                                {data.RemaingTime.Months}
                              </strong>
                              <p className="m-0">{t("month")}</p>
                            </div>
                          )}
                          {data.RemaingTime.Days.toString() !== "0" && (
                            <div>
                              <strong style={{ fontSize: "16px" }}>
                                {data.RemaingTime.Days}
                              </strong>
                              <p className="m-0">{t("day")}</p>
                            </div>
                          )}
                          {data.RemaingTime.Hours.toString() !== "0" && (
                            <div>
                              <strong style={{ fontSize: "16px" }}>
                                {data.RemaingTime.Hours}
                              </strong>
                              <p className="m-0">{t("hour")}</p>
                            </div>
                          )}
                          {data.RemaingTime.Minutes.toString() !== "0" && (
                            <div>
                              <strong style={{ fontSize: "16px" }}>
                                {data.RemaingTime.Minutes}
                              </strong>
                              <p className="m-0">{t("minute")}</p>
                            </div>
                          )}
                          {data.RemaingTime.Years === 0 &&
                            data.RemaingTime.Months === 0 &&
                            data.RemaingTime.Days === 0 &&
                            data.RemaingTime.Hours === 0 &&
                            data.RemaingTime.Minutes === 0 &&
                            data.RemaingTime.Seconds === 0 && (
                              <div className="no-time-remain">
                                <p>{"زمان دوره فعلی به اتمام رسیده است"}</p>
                              </div>
                            )}
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="mt-4 w-100 text-center text-muted">
                      <Translator id="noData2Display" />
                    </div>
                  )}
                </div>
              </DialogContent>

              <DialogActions>
                <MuiButton
                  color="primary"
                  onClick={enterDashboard}
                  title={<Translator id="enterDashboard" />}
                  innerIcon={<Icons.ExclamationTriangle />}
                />
                <MuiButton
                  onClick={() => setShowDialog(false)}
                  title={<Translator id="close" />}
                />
              </DialogActions>
            </>
          )}
        </form>
      </Dialog>
    </>
  );
}
